import { createRouter, createWebHistory } from 'vue-router'
import publicRoutes from './publicRoutes'
import privateRoutes from './privateRoutes'
import store from '@/store'
const routes = [...publicRoutes, ...privateRoutes]

const router = createRouter({
	history: createWebHistory(process.env.BASE_URL),
	routes,
	linkActiveClass: 'active',
})

router.beforeEach(async (to, from, next) => {
	const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
	if (requiresAuth) {
		let token = store.getters.getToken
		if (!token) {
			token = localStorage.getItem('access_token_cg')
		}
		if (!token) {
			next('/login')
		} else {
			next()
		}
	} else {
		next()
	}
})
export default router
